export const formConstant = {
    displayName: {
        budget: 'Budget',
        landBudget: 'Land Budget',
        fixFlipBudget: 'Fix-Flip',
        specSheet: 'Spec Sheet',
    },
    displayLowerCase: {
        budget: 'budget',
        landBudget: 'land budget',
        fixFlipBudget: 'fix-flip',
        specSheet: 'spec sheet',
    },
    name: {
        budget: 'budget',
        landBudget: 'landbudget',
        fixFlipBudget: 'fixFlipBudget',
        specSheet: 'specsheet',
        review: 'review',
    },
};
